// Google Consent Mode v2
import type { Category, ConsentMap } from './types';

type ConsentValue = 'granted' | 'denied';

interface GcmSignals {
  ad_storage: ConsentValue;
  ad_user_data: ConsentValue;
  ad_personalization: ConsentValue;
  analytics_storage: ConsentValue;
  functionality_storage: ConsentValue;
  personalization_storage: ConsentValue;
  security_storage: ConsentValue;
}

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

function ensureGtag(): (...args: unknown[]) => void {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      (window.dataLayer as unknown[]).push(arguments);
    };
  }
  return window.gtag;
}

function toSignals(consent: Partial<ConsentMap>): GcmSignals {
  const v = (c: Category): ConsentValue => (consent[c] ? 'granted' : 'denied');
  return {
    ad_storage: v('marketing'),
    ad_user_data: v('marketing'),
    ad_personalization: v('marketing'),
    analytics_storage: v('statistics'),
    functionality_storage: v('preferences'),
    personalization_storage: v('preferences'),
    security_storage: 'granted',
  };
}

export function emitDefaults(consent: Partial<ConsentMap>): void {
  const gtag = ensureGtag();
  gtag('consent', 'default', { ...toSignals(consent), wait_for_update: 500 });
  (window.dataLayer as unknown[]).push({ event: 'tc_consent_default', tc: toSignals(consent) });
}

export function emitUpdate(consent: ConsentMap): void {
  const gtag = ensureGtag();
  gtag('consent', 'update', toSignals(consent));
  (window.dataLayer as unknown[]).push({ event: 'tc_consent_update', tc: toSignals(consent) });
}
